export default __webpack_public_path__ + "static/media/himanshu-bhardwaj-post.2090319d.png";